import React, { useEffect, useState } from "react";
import PublicCatalogLayout from "../layouts/PublicCatalogLayout"
import { isJaguar, hasClientAccess } from "@/utility/UserUtils";
import { Link } from "@mui/material";
const ReportIndex = (props) => {
  const reportSectionClasses = "mb-6";
  const headerClasses = " text-xl font-medium font-['Roboto']";

  const renderRenterReports = (renter) => {
    if(hasClientAccess(props.user, renter)) {
      return (
        <div className={reportSectionClasses}>
          <div className={headerClasses + "  text-blue-600"}>
            {renter.name} Inventory Reports
          </div>
          <div className="color-black">
            Complete Inventory Report
            <Link style={{ textDecoration: 'none' }} className="ml-2 text-decoration-none" target="_blank" href={`/warehouse/reports/renter_full_billing?id=${renter.id}`}>
            Download
            </Link>
          </div>
        </div>
      )
    }else {
      return "x"
    }
  }
  return (
      <PublicCatalogLayout currentPage="reports" {...props}>
        <h1
          className="catalog-h1"
          currentPage="reports"
        >
          Reports
        </h1>
        <div className="mt-2"/>
        {isJaguar(props.user) && (
          <div className={reportSectionClasses}>
            <div className={headerClasses + " text-emerald-500"}>
              Jaguar Design Studio Inventory Reports
            </div>
            <div>
              N/A - In Progress
            </div>
          </div>

        )}
        {props.renters.sort((a, b) => a.name.localeCompare(b.name)).map((renter) => renderRenterReports(renter))}
      </PublicCatalogLayout>
  );
};

export default ReportIndex;